"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ConsoleTelemetryProvider = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _ISS = require("./ISS");

var ConsoleTelemetryProvider = /*#__PURE__*/function () {
  function ConsoleTelemetryProvider() {
    (0, _classCallCheck2.default)(this, ConsoleTelemetryProvider);
    this.enabled = false;
    this._sessionId = void 0;

    this.logger = function (message) {
      var _console, _context;

      for (var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        optionalParams[_key - 1] = arguments[_key];
      }

      (_console = console).log.apply(_console, (0, _concat.default)(_context = [message]).call(_context, optionalParams));
    };
  }

  (0, _createClass2.default)(ConsoleTelemetryProvider, [{
    key: "initialize",
    value: function initialize() {
      this.logger('ConsoleTelemetry: initialized');
    }
  }, {
    key: "setUserId",
    value: function setUserId(userId, pii, userIdType) {// No logging needed
    }
  }, {
    key: "getSessionId",
    value: function getSessionId() {
      return this._sessionId;
    }
  }, {
    key: "setSessionId",
    value: function setSessionId(sessionId) {
      this._sessionId = sessionId;
    }
  }, {
    key: "logSession",
    value: function logSession(state, eventData) {
      this.logger('logSession', state, eventData);
    }
  }, {
    key: "logEvent",
    value: function logEvent(eventData) {
      this.logger('logEvent', eventData.getPropertyMap()[_ISS.IssPropertyName.Action_OperationName], eventData);
    }
  }, {
    key: "logPageView",
    value: function logPageView(id, pageName, category, uri, referrerUri, event) {
      this.logger('logPageView', id, pageName, category, uri, referrerUri, event);
    }
  }, {
    key: "logFailure",
    value: function logFailure(signature, detail, category, id, properties) {
      this.logger('logFailure', properties && properties.getPropertyMap()[_ISS.IssPropertyName.Action_OperationName], signature, detail, category, id, properties);
    }
  }, {
    key: "flush",
    value: function flush() {
      this.logger('flushed');
    }
  }, {
    key: "flushAndTeardown",
    value: function flushAndTeardown() {
      this.logger('flushAndTeardown');
    }
  }]);
  return ConsoleTelemetryProvider;
}();

exports.ConsoleTelemetryProvider = ConsoleTelemetryProvider;